<script>
  /* eslint-disable new-cap */
import Layout from '@layouts/primary'
import { collectionMethods, clientMethods, serviceMethods, runsheetMethods } from '@state/helpers'
import store from '@state/store'

export default {
  $_veeValidate: {
    validator: 'new',
  },
  page: {
    title: 'Collections',
    meta: [{ name: 'description', content: 'Collections' }],
  },
  components: { Layout },
  data() {
    return {
      search: '',
      headers: [
        { text: 'Client Number', value: 'client_id' },
        { text: 'Client Name', value: 'client_name' },
        { text: 'Address', value: 'address' },
        { text: 'Suburb', value: 'suburb' },
        { text: 'Post Code', value: 'postcode' },
        // { text: 'Phone', value: 'phone' },
        // { text: 'SMS Direct', value: 'mobile' },
        { text: 'Collection Date', value: 'collection_date' },
        { text: 'Access Time', value: 'expected_collection_time' },
        { text: 'Status', value: 'status' },
        { text: 'Actions', value: 'name', sortable: false },
      ],
      collectionsList: [],
      clients:[],
      clientsData:[],
      services:[],
      currentService:[],
      runSheets:[],
      newCollection: {
        client: null,
        driver_id: null,
        service_id: null,
        service_title: null,
        expected_collection_time: null,
        created_by: null,
        collection_date: null,
        collection_time: null,
        order: null,
        lat: null,
        lon: null,
        completed: false, // Default value
        processed: false, // Default value
        runSheetId: null,
        site: {},
      },
      dateDialog: false,
      dictionary: {
        attributes: {
          // email: 'E-mail Address',
          // custom attributes
        },
        custom: {
          // name: {
          //   required: () => 'Name can not be empty',
          //   max: 'The name field may not be greater than 10 characters',
          //   // custom messages
          // },
          select: {
            required: 'Select field is required',
          },
        }
      },
      addCollection: false,
    }
  },
  mounted() {
    this.$validator.localize('en', this.dictionary)

    // @TODO remove "3" and pass current service ID as parameter
    this.getCollectionsByServiceId({ServiceId: 3}).then(response => {
      let obj = this.$store.state.collections.objects
      // // console.log(obj)
      let moment = require('moment');
      for (let v in obj) {

        // Create a copy of the object to update it
        let formattedObj = {
          ...obj[v]
        }

        // Convert to Hours
        if(obj[v].expected_collection_time){
          let serviceTime = obj[v].expected_collection_time
          let hours = new moment(serviceTime * 1000);
          formattedObj.expected_collection_time = hours.format('H:mm')
        }

        // Convert Date
        if(obj[v].collection_date){
          formattedObj.collection_date = moment(obj[v].collection_date).format('DD/MM/YYYY')
        }

        if(obj[v].completed || obj[v].completed === "Finished"){
          formattedObj.completed = "Finished"
        }else if(!obj[v].completed || obj[v].completed === "In Progress"){
          formattedObj.completed = "In Progress"
        }

        this.collectionsList.push(formattedObj)
      }
    })
    this.getClients().then(response => {
      let obj = this.$store.state.clients.objects
      for (let v in obj) {
        this.clients.push(obj[v])
      }
      this.clientsData = this.clients.map(index => { return { client_id: index.id, client_name: index.client_name } })
    })
  },
  methods: {
    ...collectionMethods, ...clientMethods, ...serviceMethods, ...runsheetMethods,
    submit() {
      this.$validator.validateAll()
      this.createNewCollection()
    },
    computedDateFormattedMomentjs () {
      // @TODO check why its complaining when convert date
      // let moment = require('moment');
      // this.newCollection.collection_date = moment(this.newCollection.collection_date).format('DD/MM/YYYY')
    },
    async createNewCollection(){
      let userId = store.getters['auth/getUserId'];

      let serviceId = this.newCollection.service_id
      let expectedCollectionTime = this.newCollection.expected_collection_time
      let createdBy = userId
      let collectionDate = this.newCollection.collection_date
      let collectionTime = this.newCollection.expected_collection_time
      let order = this.newCollection.order
      let completed = this.newCollection.completed
      let processed = this.newCollection.processed
      let runsheetId = this.newCollection.runSheetId

      await this.createCollection({
        service_id: parseInt(serviceId),
        expected_collection_time: expectedCollectionTime,
        created_by: createdBy,
        collection_date: collectionDate,
        collection_time: collectionTime,
        order: order,
        completed: completed,
        processed: processed,
        runsheetId: runsheetId
      })
        .then(d => {
          location.reload()
        })
    },
    clear() {
      this.newCollection = {}
      this.$validator.reset()
      this.addCollection = false
    },
    changeRoute(r) {
      this.$router.push(r)
    },
    getClientID(client){
      let cid = null
      for(let i in this.clientsData){
        if(client === this.clientsData[i].client_name){
          cid = this.clientsData[i].client_id;
        }
      }
      return cid;
    },
    async getRunSheets(date){
      await this.getRunsheetsByDate({date: date}).then(response => {
        this.runSheets = response;
      })
    },
    async onClientChange(client){
      // Clean current data before populate again
      this.services = []
      this.currentService = []
      this.newCollection.site = {}
      let cid = this.getClientID(client)

      await this.getServiceByClientId({id: cid}).then(response => {
        this.services = response
      })
    },
    setCurrentService(service){
      for(let i in this.services){
        if(service === this.services[i].service_title){
          this.currentService = this.services[i].site;
          this.newCollection.site = this.currentService;
          this.newCollection.service_id = this.services[i].id
          this.newCollection.service_title = this.services[i].service_title
        }
      }
    },
    onServiceChange(service){
      this.setCurrentService(service)
    },
    onDateChange(date){
      // Convert Date format
      this.computedDateFormattedMomentjs()
      this.dateDialog = false;
      this.getRunSheets(date);
    },
    onRunSheetSelected(id){
      // Determine the collection order
      for(let i in this.runSheets){
        if (this.runSheets[i].id === id){
          // Get last collection position
          if(this.runSheets[i].collections.length > 0 ){
            this.newCollection.order = this.runSheets[i].collections.length;
          } else {
            // Otherwise will be first collection order
            this.newCollection.order = 1;
          }
        }
      }
    }
  },
}
</script>

<template>
  <Layout>
    <VContainer>
      <div class="">
        <h2 :class="$style.routeHeader">
          Collections
        </h2>
      </div>
      <VBtn
        slot="activator"
        :class="$style.addButton"
        color="blue"
        @click="addCollection = !addCollection"
      >
        + ADD COLLECTION
      </VBtn>
      <VLayout style="width: 100%">

        <VFlex
          xs0
          sm12
        />
        <VFlex
          xs12
          md5
        >
          <VTextField
            v-model="search"
            append-icon="search"
            label="Search"
            single-line
            hide-details
          />
        </VFlex>
      </VLayout>

      <VDataTable
        :headers="headers"
        :items="collectionsList"
        :search="search"
        rows-per-page-text=""
        :rows-per-page-items="[10]"
      >
        <template
          slot="items"
          slot-scope="props"
        >
          <td class="text-xs-left">
            {{ props.item.client.id }}
          </td>
          <td class="text-xs-left">
            {{ props.item.client.client_name }}
          </td>
          <td class="text-xs-left">
            {{ props.item.site.address }}
          </td>
          <td class="text-xs-left">
            {{ props.item.site.suburb }}
          </td>
          <td class="text-xs-left">
            {{ props.item.site.postcode }}
          </td>
          <!--<td class="text-xs-left">-->
          <!--{{ props.item.site.phone }}-->
          <!--</td>-->
          <!--<td class="text-xs-left">-->
          <!--{{ props.item.site.mobile }}-->
          <!--</td>-->
          <td class="text-xs-left">
            {{ props.item.collection_date }}
          </td>
          <td class="text-xs-left">
            {{ props.item.expected_collection_time }}
          </td>
          <td class="text-xs-left">
            {{ props.item.completed }}
          </td>

          <td class="justify-center px-0">
            <VBtn
              slot="activator"
              style="display: block; position:relative; margin: 0 auto"
              color="blue"
              @click.native="changeRoute({name: 'view-collection', params: {id: props.item.id}})"
            >
              View
            </VBtn>
          </td>
        </template>
        <VAlert
          slot="no-results"
          :value="true"
          color="error"
          icon="warning"
        >
          Your search for "{{ search }}" found no results.
        </VAlert>
      </VDataTable>
    </VContainer>

    <!-- ADD COLLECTION MODAL -->
    <VLayout
      row
      justify-center
    >
      <VDialog
        v-model="addCollection"
        persistent
        max-width="500px"
        scrollable
      >
        <VCard>
          <VCardText>
            <VContainer grid-list-md>
              <h2>New Collection</h2>
              <VLayout wrap>

                <VFlex xs12>
                  <VSelect
                    v-model="newCollection.client"
                    :items="clients"
                    item-text="client_name"
                    label="Client"
                    required
                    :menu-props="{ absolute: true }"
                    attach
                    @change="onClientChange(newCollection.client)"
                  />
                </VFlex>

                <VFlex xs12>
                  <VSelect
                    v-model="newCollection.service_title"
                    :items="services"
                    item-text="service_title"
                    label="Service"
                    required
                    :menu-props="{ absolute: true }"
                    attach
                    @change="onServiceChange(newCollection.service_title)"
                  />
                </VFlex>

                <VFlex xs12>
                  <VTextField
                    v-model="newCollection.site.trading_name"
                    label="Trading Name"
                    required
                    readonly
                  />
                </VFlex>

                <VFlex xs12>
                  <VTextField
                    v-model="newCollection.site.address"
                    label="Address"
                    required
                    readonly
                  />
                </VFlex>

                <VLayout wrap>
                  <VFlex xs3>
                    <VTextField
                      v-model="newCollection.site.postcode"
                      label="Post Code"
                      required
                      readonly
                    />
                  </VFlex>
                  <VFlex xs9>
                    <VTextField
                      v-model="newCollection.site.suburb"
                      label="Suburb"
                      required
                      readonly
                    />
                  </VFlex>
                </VLayout>

                <VLayout wrap>
                  <VFlex xs6>
                    <VTextField
                      v-model="newCollection.site.mobile"
                      label="Mobile"
                      required
                      readonly
                    />
                  </VFlex>
                  <VFlex xs6>
                    <VTextField
                      v-model="newCollection.site.phone"
                      label="Phone"
                      required
                      readonly
                    />
                  </VFlex>
                </VLayout>

                <VLayout wrap>
                  <VFlex xs6>
                    <VDialog
                      v-model="dateDialog"
                      persistent
                      width="290px"
                    >
                      <VTextField
                        slot="activator"
                        v-model="newCollection.collection_date"
                        label="Date"
                        append-icon="event"
                        readonly
                      />
                      <VDatePicker
                        v-model="newCollection.collection_date"
                        header-color="#00baff"
                        color="#00baff"
                        scrollable
                        @input="onDateChange(newCollection.collection_date)"
                      />
                    </VDialog>
                  </VFlex>
                  <VFlex xs6>
                    <VTextField
                      v-model="newCollection.expected_collection_time"
                      label="Access Time"
                      required
                    />
                  </VFlex>
                </VLayout>
                <VFlex xs12>
                  <VSelect
                    v-model="newCollection.runSheetId"
                    :items="runSheets"
                    item-text="id"
                    label="Run Sheet"
                    required
                    :menu-props="{ absolute: true }"
                    attach
                    @input="onRunSheetSelected(newCollection.runSheetId)"
                  />
                </VFlex>

                <VFlex
                  xs12
                  sm6
                  md6
                >
                  <VBtn
                    color="blue"
                    block
                    outline
                    @click.native="addCollection = false"
                  >
                    Close
                  </VBtn>
                </VFlex>
                <VFlex
                  xs12
                  sm6
                  md6
                >
                  <VBtn
                    color="blue"
                    block
                    @click.native="createNewCollection()"
                  >
                    Save
                  </VBtn>
                </VFlex>
              </VLayout>
            </VContainer>
          </VCardText>
        </VCard>
      </VDialog>
    </VLayout>

  </Layout>
</template>

<style lang="scss" module>
@import '@design';

.routeHeader {
  display: inline-block;
}

.addButton {
  display: inline-block;
  float: right;
}
</style>
